import { ALPHA_2_ISO_3166, PERSONAL_STATUS, SALUTATIONS, TITLES } from 'cpool-constants';
import { z } from 'zod';

import { regex_iso_date } from '../../../utils/regex.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#personendaten

	{
		"anrede": "FRAU" | "HERR",
		"email": String,
		"familienstand": "LEDIG" | "VERHEIRATET" | "GESCHIEDEN" | "VERWITWET" | "GETRENNT_LEBEND" | "EHEAEHNLICHE_LEBENSGEMEINSCHAFT" | "EINGETRAGENE_LEBENSPARTNERSCHAFT",
		"geburtsdatum": "YYYY-MM-DD",
		"geburtsname": String,
		"geburtsort": String,
		"geburtsland": "ALPHA-2 Isocode",
		"nachname": String,
		"telefonGeschaeftlich": String,
		"telefonPrivat": String,
		"titel": [ "DOKTOR" | "PROFESSOR" ],
		"vorname": String,
	}

*/

export const schemaEuropacePersonendaten = z.object({
    anrede: z.optional(z.nativeEnum(SALUTATIONS)),
    email: z.optional(z.string().email()),
    familienstand: z.optional(z.nativeEnum(PERSONAL_STATUS)),
    geburtsdatum: z.optional(z.string().regex(regex_iso_date)),
    geburtsland: z.optional(z.nativeEnum(ALPHA_2_ISO_3166)), // ALPHA-2 Isocode
    geburtsname: z.optional(z.string()),
    geburtsort: z.optional(z.string()),
    nachname: z.optional(z.string()),
    telefonGeschaeftlich: z.optional(z.string()),
    telefonPrivat: z.optional(z.string()),
    titel: z.optional(z.array(z.nativeEnum(TITLES))),
    vorname: z.optional(z.string()),
});

export type SchemaEuropacePersonendaten = z.infer<typeof schemaEuropacePersonendaten>;
